<template>
  <div class="face-confirm-view h-screen flex flex-col bg-white">
    <div style="height: 100%; padding: 0 20px">
      <van-swipe :autoplay="5000" :circular="true" style="height: 100%">
        <van-swipe-item v-for="(i, idx) in imgList" :key="idx">
          <div v-if="i.is_self == '1'" class="mt-18 mb-12 text-14 leading-20 text-default text-center">
            当前人员: {{ i.name }}
          </div>
          <div v-else class="mt-18 mb-12 text-14 leading-20 text-default text-center">同住人人脸信息：{{ i.name }}</div>
          <div class="flex justify-center items-center relative">
            <template v-if="visit_face_approval == '1'">
              <div v-if="i.state == '1'" class="absolute text-14 face-status face-status1">
                通行：人脸信息待确认
              </div>
              <div v-if="i.state == '2'" class="absolute text-14 face-status face-status2">
                通行：人脸信息已确认
              </div>
              <div v-if="i.state == '3'" class="absolute text-14 face-status face-status3">
                通行：人脸信息被驳回
              </div>
            </template>

            <!-- <img style="height: 400px" :src="i.face_pic" /> -->
            <van-image v-if="i.face_pic" width="300px" height="400px" :src="i.face_pic" />
          </div>

          <div class="flex flex-col justify-between items-center">
            <div
              class="w-300 bg-theme h-48 text-14 leading-48 rounded-6 text-center text-white mt-40 border-all-active"
              @click="handleModify(i)"
            >
              人脸信息修改
            </div>
            <template v-if="showVisitor">
              <div
                v-if="userInfo.user_type == '8' && i.is_self == '1'"
                class="w-300 text-theme h-48 text-14 leading-48 rounded-6 text-center mt-16 border-all-active"
                @click="handleAdd(i)"
              >
                新增同住人人脸信息
              </div>
            </template>
            <div
              v-if="i.is_self != '1'"
              class="w-300 border-all-orange h-48 text-14 leading-48 rounded-6 text-center mt-16 text-orange"
              @click="handleRemove(i)"
            >
              删除当前人脸信息
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <van-dialog
      v-model:show="dialogShow"
      confirm-button-color="#3d6eeb"
      title="录入人脸信息的人员姓名"
      show-cancel-button
      :before-close="beforeClose"
      @cancel="onClose"
      @confirm="onConfirm"
    >
      <div style="padding: 16px 20px 30px">
        <input v-model="faceName" class="face-name-input w-full text-14 h-48 rounded-6" placeholder="请输入" />
      </div>
    </van-dialog>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { visitorService } from "@/service";
import { vLoading } from "@/utils/loading";
import { useStore } from "@/store";
import to from "await-to-js";
import { Toast, Dialog } from "vant";
import { useRouter } from "vue-router";

const router = useRouter();

const store = useStore();
const userInfo = computed(() => store.state.userInfo);

const imgList = ref([]);
const dialogShow = ref(false);
const faceName = ref("");
const visit_face_approval = ref("1");

const showVisitor = computed(() => {
  const power = userInfo.value.power;
  console.log(power);
  if (power.includes("23")) {
    return true;
  } else {
    return false;
  }
});

const handleModify = ({ is_self, name, id }) => {
  const type = is_self == 1 ? "1" : "2";
  router.push({
    name: "submitFace",
    query: { name, type, id } // type = 2 新增同住人，1：本人修改
  });
};

const onClose = () => {
  dialogShow.value = false;
};
const beforeClose = val => {
  if (val === "confirm" && !faceName.value) {
    Toast.fail("请输入同住人脸信息的人员姓名");
    return false;
  }
};
const onConfirm = () => {
  if (!faceName.value) return;
  router.push({
    name: "submitFace",
    query: { name: faceName.value, type: 2 } // type =2 新增同住人，1：本人修改，此处传2
  });
};

const handleAdd = () => {
  faceName.value = "";
  dialogShow.value = true;
};

const handleRemove = ({ id }) => {
  Dialog.confirm({
    message: "确认删除当前人脸信息吗？"
  }).then(async () => {
    const [err] = await to(visitorService.related_face_del({ id }));
    if (err) return;
    Toast.success({ title: "删除成功", icon: "success" });
    initPage();
  });
};

const initPage = async () => {
  try {
    vLoading.start();
    const result = await Promise.all([visitorService.related_face_lists(), visitorService.config_info()]);
    imgList.value = result[0].data.data;
    visit_face_approval.value = result[1].data.data.visit_face_approval;
  } catch {
  } finally {
    vLoading.stop();
  }
};

initPage();
</script>
<style lang="less" scoped>
.face-confirm-view {
  .face-name-input {
    box-sizing: border-box;
    border: 1px solid #ccd3df;
    padding-left: 16px;
  }
}
.face-status {
  top: 0;
  color: #fff;
  border-radius: 0 0 10px 10px;
  padding: 8px 10px;
}
.face-status1 {
  background-image: linear-gradient(270deg, #3484ff 0%, #3d6eeb 98%);
}
.face-status2 {
  background-image: linear-gradient(270deg, #5ee09f 0%, #1ed278 100%);
}
.face-status3 {
  background-image: linear-gradient(270deg, #ff8264 0%, #ff5b34 100%);
}
</style>
